import { common } from './common';

export const environment = {
  ...common,
  name: 'prod',
  production: true,
  isDebugMode: false,

  apiURL: '',
  appPath: '/jwt/',
  appUrl: '',
  appRealm: 'TRAMIT-TEL',
};
